import Card, { CardContent } from '@/components/@base/card';
import { Text } from '@/components/@base/typography';
import XImage from '@/components/@base/x-image';

import imagesList from '@/constant/images-list';

import { historyType } from '../../services/type';

type NoteProps = Pick<historyType, 'note'>;
export default function Note({ note }: NoteProps) {
  return (
    <Card className='rounded-lg border-[3px] border-[#FFFFFF] bg-[#F0F8FF]'>
      <CardContent className='relative flex flex-col gap-2 py-7 pr-8 '>
        <XImage
          src={imagesList.images.comma}
          alt={note.title}
          width={45}
          height={45}
          className='absolute right-5 top-6'
        />
        <Text className='text-[15px] font-medium leading-6 text-[#5B5C60]'>{note.title}</Text>
        <blockquote className='font-light text-xs leading-6 tracking-tighter text-[#424244]'>
          {note.subtitle}
        </blockquote>
        <Text className='mt-2 text-xs font-medium leading-4 text-[#878F9B]'>
          {note.author}
        </Text>
      </CardContent>
    </Card>
  );
}
